import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";

const bulletListSx = {
    "& ul": {
        pl: 3,
        color: "#000",
        mb: 0,
        listStyleType: "disc",
    },
    "& ul li": {
        color: "#000",
        fontSize: "1rem",
        mb: 1,
        position: "relative",
        listStyleType: "disc",
    },
    "& ul li::marker": {
        color: "#0f63af",
    },
    // Use fontWeight: 700 for bold, and target both <b> and <strong>
    "& ul li strong, & ul li b": {
        fontWeight: 700,
        color: "#000",
    },
};

const RefundPolicy = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                minHeight: '100vh',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'fixed',
                    top: '60%',
                    left: '50%',
                    width: { xs: '80vw', md: '40vw' },
                    height: { xs: '80vw', md: '30vw' },
                    maxWidth: 600,
                    maxHeight: 600,
                    transform: 'translate(-50%, -50%)',
                    zIndex: 0,
                    pointerEvents: 'none',
                    opacity: 0.08,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img
                    src="https://dprstorage.b-cdn.net/RW/RW%20LOGO.png"
                    alt="Background Logo"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        filter: 'blur(0.5px)',
                        userSelect: 'none',
                    }}
                />
            </Box>
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            bgcolor: "rgba(15, 99, 165, 0.4)",
                            WebkitBackdropFilter: "blur(3px)",
                            p: 4,
                            borderRadius: 3,
                            color: "#E0E0E0",
                            boxShadow: "0px 4px 20px rgba(255, 255, 255, 0.1)",
                            textAlign: "left",
                            mt: 16,
                            ...bulletListSx,
                        }}
                    >
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#000" }}>
                            Refund Policy
                        </Typography>
                        <Typography variant="body2">
                            At <Link href="https://rajivwilliams.com" target="_blank" rel="noopener noreferrer" color="#0f63a5" underline="always">
                                rajivwilliams.com
                            </Link>, we strive to ensure your satisfaction with our products and services. If you are not entirely satisfied with your purchase, we’re here to help. Please review our refund policy below. <br />
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            1. Services
                        </Typography>
                        <Typography variant="body2" component="div">
                            <Typography variant="body2" paragraph>If you have booked a service through the website:</Typography>
                            <ul>
                                <li>Cancellations with 72+ hours’ notice: Eligible for a full refund or rescheduling.</li>
                                <li>Cancellations within 72 hours: 50% refund or one-time rescheduling, subject to availability.</li>
                                <li>No-shows or same-day cancellations: No refund will be issued.</li>
                                <li>If we must cancel or reschedule due to unforeseen circumstances, you will receive a full refund or be offered an alternative appointment.</li>
                            </ul>
                            <Typography variant="body2" paragraph>If any refund is issued, it will be processed within 3–5 business days and credited within 5–7 business working days.</Typography>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            2. Custom Projects
                        </Typography>
                        <Typography variant="body2" component="div">
                            <Typography variant="body2" paragraph >For custom work (e.g., personalized artwork, photography packages, or design services):</Typography>
                            <ul>
                                <ul>
                                    <li><b>A non-refundable deposit (typically 20–50%) is required to initiate the project.</b></li>
                                    <li><b>Remaining balance is refundable only if the project has not yet started.</b></li>
                                    <li><b>No refunds will be issued after the work has been delivered or partially completed unless there is a breach of service or quality agreement.</b></li>
                                </ul>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            3. How to Request a Refund
                        </Typography>
                        <Typography variant="body2" component="div">
                            <Typography variant="body2" paragraph>To request a refund or report an issue, please email us at:</Typography>
                            <ul>
                                <li> <b>Email:</b> <a href="mailto:accounts@dezignshark.com">accounts@dezignshark.com</a></li>
                                <li>Include your:</li>
                                <ul>
                                    <li>Full name</li>
                                    <li>Order number or service date</li>
                                    <li>Reason for your request</li>
                                </ul>
                            </ul>
                        </Typography>
                        <Typography variant="body2">We aim to respond within <b>3 business days</b> .</Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            4. Late or Missing Refunds
                        </Typography>
                        <Typography variant="body2" component="div">
                                <Typography variant="body2" paragraph>If your refund has been approved but not received:</Typography>
                            <ul>
                                <ul>
                                    <li>Check your bank or payment method again</li>
                                    <li>Contact your payment provider (processing times vary)</li>
                                </ul>
                                <li>If you’ve done this and still have not received your refund, contact us at <a href="mailto:accounts@dezignshark.com">accounts@dezignshark.com</a></li>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            5. Policy Changes
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <li>We reserve the right to modify this refund policy at any time. Any changes will be posted on this page with an updated effective date.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default RefundPolicy;
